/**
 * @name tablet.constants
 * @description Core tablet.constants in ngx-responsive
 *
 * @license MIT
 */
import { ITablet } from '../interfaces';

export const TABLET: ITablet = {
    IPAD: 'Ipad',
    ANDROID: 'Android',
    WINDOWS_PHONE: 'Windows Phone',
    KINDLE: 'Kindle',
    GENERIC_TABLET: 'Generic Tablet'
};
